import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Processo, ISprocesso } from '../../types/processo/Processo';
import { Documento } from '../../types/processo/Documento';

//essa classe ira guardar o processo selecionado. 


interface processoSelecionado {
    processoSelecionado: Processo | null;
};


const initialState: processoSelecionado = {
    processoSelecionado: null,
};


const processoSelecionadoSlice = createSlice({
    name: 'processoSelecionadoSlice',
    initialState,
    reducers: {

        setProcessoSelecioadoSlice: (state, action: PayloadAction<Processo>) => {
            state.processoSelecionado = action.payload;
        },
        setNullProcessoSelecioadoSlice: (state) => {
            state.processoSelecionado = null;
        },
        addDocumentoProcessoSelecioadoSlice: (state, action: PayloadAction<Documento>) => {
            // Verifica se o processoSelecionado existe e se a propriedade documentos é um array
            if (state.processoSelecionado) {
                // Garantir que a propriedade documentos exista
                if (!state.processoSelecionado.documentos) {
                    state.processoSelecionado.documentos = [];  // Inicializa se não existir
                }
                state.processoSelecionado.documentos.push(action.payload);
            }
        },
        editDocumentoProcessoSelecioadoSlice: (state, action: PayloadAction<Documento>) => {
            if (state.processoSelecionado) {
                // Percorre o array de documentos para encontrar o documento com o id fornecido
                const index = state.processoSelecionado.documentos.findIndex((doc) => doc.id === action.payload.id);
                if (index > -1) {
                    // Se o documento for encontrado, substitui o documento com o novo
                    state.processoSelecionado.documentos[index] = action.payload;
                }
            }
        },
    }
});

export const {
    setProcessoSelecioadoSlice,
    setNullProcessoSelecioadoSlice,
    addDocumentoProcessoSelecioadoSlice,
    editDocumentoProcessoSelecioadoSlice,
} = processoSelecionadoSlice.actions;

export default processoSelecionadoSlice.reducer;